<template>
  <div v-if="distributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="distributions"
      dataFormaterKey="order.shop.print_distribution_template.template"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Orders from "@/api/orders";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "../distributions/makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    distributions: [],
  }),
  
  computed: {
    ...mapState(["accountUser"]),
  },

  mounted() {
    PrintTemplates.fetchOne("distribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.formater = response.data.print_template.template;
          //获取单据详情
          Orders.ordersToDistributionPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                var orders = response.data.orders;
                var distributions = [];
                if (orders)
                  orders.forEach((order) => {
                    if (order.distributions) {
                      order.shop = this.$printUtils.addCitiesName(order.shop);
                      order.distributions.forEach((distribution) => {
                        distributions.push({
                          order: order,
                          distribution: makeData.processDetails(distribution),
                          order_address: distribution.order_address,
                          print_date: new Date().toISOString().substr(0, 10),
                          printDateMinutes:
                            this.$datetimeUtils.formatDateMinutes(new Date()),
                          accountUserName: this.accountUser.name,
                        });
                      });
                    }
                  });
                this.distributions = distributions;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>